var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0496 12L7.17461 6.575C6.94128 6.24167 6.91211 5.89583 7.08711 5.5375C7.26211 5.17917 7.55794 5 7.97461 5C8.14128 5 8.29961 5.0375 8.44961 5.1125C8.59961 5.1875 8.71628 5.29167 8.79961 5.425L13.4996 12L8.79961 18.575C8.71628 18.7083 8.59961 18.8125 8.44961 18.8875C8.29961 18.9625 8.14128 19 7.97461 19C7.57461 19 7.28294 18.8208 7.09961 18.4625C6.91628 18.1042 6.94128 17.7583 7.17461 17.425L11.0496 12ZM16.9996 12L13.1246 6.575C12.8913 6.24167 12.8621 5.89583 13.0371 5.5375C13.2121 5.17917 13.5079 5 13.9246 5C14.0913 5 14.2496 5.0375 14.3996 5.1125C14.5496 5.1875 14.6663 5.29167 14.7496 5.425L19.4496 12L14.7496 18.575C14.6663 18.7083 14.5496 18.8125 14.3996 18.8875C14.2496 18.9625 14.0913 19 13.9246 19C13.5246 19 13.2329 18.8208 13.0496 18.4625C12.8663 18.1042 12.8913 17.7583 13.1246 17.425L16.9996 12Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.756e5c609fbe6bc9d1c7355936c981bf.svg";
export { ForwardRef as ReactComponent };